import {
  ICreateProfileActionPayload,
  IUpdateProfileActionPayload,
  IFetchProfilesPayload,
  IFetchProfilesSuccessActionPayload,
  ICreateProfileAction,
  ICreateProfileSuccessAction,
  IUpdateProfileAction,
  ICreateProfileFailureAction,
  IUpdateProfileFailureAction,
  IFetchProfilesFailureAction,
  IUpdateProfileSuccessAction,
  IFetchProfilesAction,
  IFetchProfilesSuccessAction,
  IProfileData,
  ICreateProfileSuccessActionPayload,
  IDeleteAddressAction,
  IDeleteAddressActionPayload,
  IDeleteAddressFailureAction,
  IDeleteAddressSuccessAction,
  IDeleteAddressSuccessActionPayload,
  IsetProfileImageAction,
  IsetProfileImagePayload,
  IsetCurrentLoggedinUserIdAction,
  IProfileMap,
  IsetLoggedInUserProfileCompleted,
} from "@common/redux/profile/interface";

const prefix = "profile/";

export const profileActions = {
  FETCH_PROFILES: `${prefix}FETCH_PROFILES`,
  FETCH_PROFILES_SUCCESS: `${prefix}FETCH_PROFILES_SUCCESS`,
  FETCH_PROFILES_FAILURE: `${prefix}FETCH_PROFILES_FAILURE`,
  SET_PROFILE_MAP: `${prefix}SET_PROFILE_MAP`,

  FETCH_ORGANIZATION: `${prefix}FETCH_ORGANIZATION`,
  FETCH_ORGANIZATION_SUCCESS: `${prefix}FETCH_ORGANIZATION_SUCCESS`,
  FETCH_ORGANIZATION_FAILURE: `${prefix}FETCH_ORGANIZATION_FAILURE`,

  CREATE_PROFILE: `${prefix}CREATE_PROFILE`,
  CREATE_PROFILE_SUCCESS: `${prefix}CREATE_PROFILE_SUCCESS`,
  CREATE_PROFILE_FAILURE: `${prefix}CREATE_PROFILE_FAILURE`,

  FETCH_PROFILE_DETAILS: `${prefix}FETCH_PROFILE_DETAILS`,
  FETCH_PROFILE_DETAILS_SUCCESS: `${prefix}FETCH_PROFILE_DETAILS_SUCCESS`,
  FETCH_PROFILE_DETAILS_FAILURE: `${prefix}FETCH_PROFILE_DETAILS_FAILURE`,

  UPDATE_PROFILE_DETAILS: `${prefix}UPDATE_PROFILE_DETAILS`,
  UPDATE_PROFILE_DETAILS_SUCCESS: `${prefix}UPDATE_PROFILE_DETAILS_SUCCESS`,
  UPDATE_PROFILE_DETAILS_FAILURE: `${prefix}UPDATE_PROFILE_DETAILS_FAILURE`,

  DELETE_ADDRESS: `${prefix}DELETE_ADDRESS`,
  DELETE_ADDRESS_SUCCESS: `${prefix}DELETE_ADDRESS_SUCCESS`,
  DELETE_ADDRESS_FAILURE: `${prefix}DELETE_ADDRESS_FAILURE`,

  SET_PROFILE_IMAGE: `${prefix}SET_PROFILE_IMAGE`,

  SET_CURRENT_LOGGEDIN_USER_ID: `${prefix}SET_CURRENT_LOGGEDIN_USER_ID`,

  SET_IS_LOGGEDIN_USER_PROFILE_COMPLETED: `${prefix}SET_IS_LOGGEDIN_USER_PROFILE_COMPLETED`,

  REGISTER_ORGANISATION: `${prefix}REGISTER_ORGANISATION`,
  REGISTER_ORGANISATION_SUCCESS: `${prefix}REGISTER_ORGANISATION_SUCCESS`,
  REGISTER_ORGANISATION_FAILURE: `${prefix}REGISTER_ORGANISATION_FAILURE`,

  UPDATE_ORGANISATION: `${prefix}UPDATE_ORGANISATION`,
  UPDATE_ORGANISATION_SUCCESS: `${prefix}UPDATE_ORGANISATION_SUCCESS`,
  UPDATE_ORGANISATION_FAILURE: `${prefix}UPDATE_ORGANISATION_FAILURE`,

};

export const createProfileAction = (
  profileData: ICreateProfileActionPayload
): ICreateProfileAction => {
  return {
    type: profileActions.CREATE_PROFILE,
    payload: profileData,
  };
};

export const createProfileSuccessAction = (
  profileData: ICreateProfileSuccessActionPayload
): ICreateProfileSuccessAction => {
  return {
    type: profileActions.CREATE_PROFILE_SUCCESS,
    payload: profileData,
  };
};

export const createProfileFailureAction = (
  error: string
): ICreateProfileFailureAction => {
  return {
    type: profileActions.CREATE_PROFILE_FAILURE,
    payload: error,
  };
};
export const updateProfileAction = (
  profileData: IUpdateProfileActionPayload
): IUpdateProfileAction => {
  return {
    type: profileActions.UPDATE_PROFILE_DETAILS,
    payload: profileData,
  };
};

export const updateProfileSuccessAction = (
  profileData: IProfileData
): IUpdateProfileSuccessAction => {
  return {
    type: profileActions.UPDATE_PROFILE_DETAILS_SUCCESS,
    payload: profileData,
  };
};

export const updateProfileFailureAction = (
  error: string
): IUpdateProfileFailureAction => {
  return {
    type: profileActions.UPDATE_PROFILE_DETAILS_FAILURE,
    payload: error,
  };
};

export const fetchProfilesAction = (
  pagination: IFetchProfilesPayload
): IFetchProfilesAction => {
  return {
    type: profileActions.FETCH_PROFILES,
    payload: pagination,
  };
};

export const fetchProfilesSuccessAction = (
  profilesMap: IProfileMap
): IFetchProfilesSuccessAction => {
  return {
    type: profileActions.FETCH_PROFILES_SUCCESS,
    payload: profilesMap,
  };
};

export interface IFetchOrganizationAction {
  type: string;
  payload: IFetchOrganizationActionPayload;
}

export interface IFetchOrganizationActionPayload {
  pageNumber: number;
  pageSize: number;
}

export interface IOrganizationsData {
  content: IOrganizationData[];
  numberOfElements: number;
  pageNumber: number;
  pageSize: number;
  totalElements: number;
  totalPages: number;
  first: boolean;
  last: boolean;
  empty: boolean
}

export const fetchProfilesFailureAction = (
  error: string
): IFetchProfilesFailureAction => {
  return {
    type: profileActions.FETCH_PROFILES_FAILURE,
    payload: error,
  };
};

export const fetchOrganizationAction = (
  payload: IFetchOrganizationActionPayload
): IFetchOrganizationAction => {
  return {
    type: profileActions.FETCH_ORGANIZATION,
    payload,
  };
};

export const fetchOrganizationSuccessAction = (organizationsData: IOrganizationsData) => {
  return {
    type: profileActions.FETCH_ORGANIZATION_SUCCESS,
    payload: organizationsData,
  };
};

export const fetchOrganizationFailureAction = (error: string) => {
  return {
    type: profileActions.FETCH_ORGANIZATION_FAILURE,
    payload: error,
  };
};

export const deleteAddresssAction = (
  address: IDeleteAddressActionPayload
): IDeleteAddressAction => {
  return {
    type: profileActions.DELETE_ADDRESS,
    payload: address,
  };
};

export const deleteAddressSuccessAction = (
  updatedProfileData: IDeleteAddressSuccessActionPayload
): IDeleteAddressSuccessAction => {
  return {
    type: profileActions.DELETE_ADDRESS_SUCCESS,
    payload: updatedProfileData,
  };
};

export const deleteAddressFailureAction = (
  error: string
): IDeleteAddressFailureAction => {
  return {
    type: profileActions.DELETE_ADDRESS_FAILURE,
    payload: error,
  };
};

export const setProfileImageAction = (
  payload: IsetProfileImagePayload
): IsetProfileImageAction => {
  return {
    type: profileActions.SET_PROFILE_IMAGE,
    payload,
  };
};
export const setProfileMapAction = (
  payload: IProfileMap
) => {
  return {
    type: profileActions.SET_PROFILE_MAP,
    payload,
  };
};
export const setCurrentLoggedinUserIdAction = (
  currentLoggedInUserId: string
): IsetCurrentLoggedinUserIdAction => {
  return {
    type: profileActions.SET_CURRENT_LOGGEDIN_USER_ID,
    payload: currentLoggedInUserId,
  };
};

export const setLoggedInUserProfileCompleted = (
  payload: boolean
): IsetLoggedInUserProfileCompleted => {
  return {
    type: profileActions.SET_IS_LOGGEDIN_USER_PROFILE_COMPLETED,
    payload,
  };
};
export interface IRegisterOrganizationActionPayload {
  title: string;
  location: string;
  website: string;
  roleInOrg: string;
  noOfEmployees: string;
}

export interface IRegisterOrganizationAction {
  type: string;
  payload: IRegisterOrganizationActionPayload;
}

export const registerOrganizationAction = (
  organisationRegisterData: IRegisterOrganizationActionPayload
): IRegisterOrganizationAction => {
  return {
    type: profileActions.REGISTER_ORGANISATION,
    payload: organisationRegisterData,
  };
};

export interface IOrganizationData {
  id?: number;
  userId?: number;
  title: string;
  location: string;
  website: string;
  roleInOrg: string;
  noOfEmployees: string;
  status?: boolean;
  applications?: null;
}

export const registerOrganizationActionSuccess = (
  orgData: IOrganizationData
) => {
  return {
    type: profileActions.REGISTER_ORGANISATION_SUCCESS,
    payload: orgData,
  };
};

export const registerOrganizationActionFailure = (error: string) => {
  return {
    type: profileActions.REGISTER_ORGANISATION_FAILURE,
    payload: error,
  };
};

export interface IUpdateOrganizationAction {
  type: string;
  payload: IOrganizationData;
}

export const updateOrganizationAction = (
  organisationData: IOrganizationData
): IUpdateOrganizationAction => {
  return {
    type: profileActions.UPDATE_ORGANISATION,
    payload: organisationData,
  };
};

export const updateOrganizationSuccessAction = (
  organisationData: IOrganizationData
) => {
  return {
    type: profileActions.UPDATE_ORGANISATION_SUCCESS,
    payload: organisationData,
  };
};

export const updateOrganizationFailureAction = (error: string) => {
  return {
    type: profileActions.UPDATE_ORGANISATION_FAILURE,
    payload: error,
  };
};
